import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Loader2, Package } from "lucide-react";

export default function ScanPartPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/scan/part/${token}`)
      .then(({ data }) => navigate(`/parts/${data.id}`, { replace: true }))
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail)));
  }, [token, navigate]);

  return (
    <div className="max-w-lg mx-auto" data-testid="scan-part-page">
      <Link to="/parts" className="font-mono text-xs text-[#B01E28] underline">← parts</Link>
      <h1 className="font-display text-2xl font-bold tracking-tight mt-3">Scanned tag</h1>
      <p className="text-xs text-slate-500 font-mono mb-4 break-all">token: {token}</p>
      {error ? (
        <div className="border border-destructive text-destructive p-4 text-sm" data-testid="scan-part-error">{error}</div>
      ) : (
        <div className="flex items-center gap-2 text-slate-500 text-sm" data-testid="scan-part-loading">
          <Loader2 className="w-4 h-4 animate-spin" /><Package className="w-4 h-4" /> Opening part record…
        </div>
      )}
    </div>
  );
}
